module.exports = __webpack_public_path__ + "static/media/ncco.428d858a.png";